import ApiService from '@/core/services/api.service';

const BASE_URL = 'purchase-order/share';

const PurchaseOrderShareService = {
  getById(id) {
    return ApiService.query(`${BASE_URL}/${id}`);
  },
  create(data) {
    return ApiService.post(BASE_URL, data);
  },
  update(id, data) {
    return ApiService.put(`${BASE_URL}/${id}`, data);
  },
  // P4 — Aggregate phiếu nhập xuất kho của tất cả Con
  listStockSlipsAggregate(parentId) {
    return ApiService.query(`${BASE_URL}/${parentId}/stock-slips`);
  },
};

export default PurchaseOrderShareService;
